import { createFileRoute } from '@tanstack/react-router';
import * as React from 'react';

import { UsersClient } from '@/components/admin/users-client';
import { PageHeader } from '@/components/dashboard/page-header';

export const Route = createFileRoute('/_admin/admin/users')({
  component: UsersPage,
});

function UsersPage(): React.ReactElement {
  return (
    <div className="mx-auto flex w-full max-w-7xl flex-col gap-6">
      <PageHeader title="Utilisateurs" subtitle="Liste et gestion des comptes." />
      <UsersClient />
    </div>
  );
}
